import { AxiosPromise } from 'axios';

import { GetVaccinesParams, PaginatedResponse, Vaccine, VaccineListItem } from 'shared/api';
import { apiInstance } from 'shared/api/typicode/base';

const BASE_URL = '/vaccine';

/**
 * Получение списка вакцин с пагинацией и фильтрацией
 * @param params - Параметры запроса (фильтрация, сортировка, пагинация)
 * @returns Promise с ответом, содержащим массив вакцин и информацию о пагинации
 */
export const getVaccinesAll = async (params: GetVaccinesParams): AxiosPromise<PaginatedResponse<VaccineListItem>> =>
  apiInstance.get(`${BASE_URL}/all`, {
    params,
    headers: {
      Authorization: `Bearer ${window.localStorage.getItem('token') ?? ''}`,
    },
  });

/**
 * Получение вакцины по ID
 * @param id - ID вакцины
 * @returns Promise с полным объектом вакцины
 */
export const getVaccineById = async (id: string): AxiosPromise<Vaccine> =>
  apiInstance.get(`${BASE_URL}/${id}`, {
    headers: {
      Authorization: `Bearer ${window.localStorage.getItem('token') ?? ''}`,
    },
  });

/**
 * Добавление новой вакцины
 */
export const postVaccine = async (data: Omit<Vaccine, '_id'>): AxiosPromise<Vaccine> =>
  apiInstance.post(`${BASE_URL}`, data, {
    headers: {
      Authorization: `Bearer ${window.localStorage.getItem('token') ?? ''}`,
    },
  });

/**
 * Обновление вакцины
 */
export const patchVaccine = async (data: Vaccine): AxiosPromise<Vaccine> => {
  const { _id, ...datas } = data;

  return apiInstance.patch(
    `${BASE_URL}/${_id}`,
    { ...datas },
    {
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem('token') ?? ''}`,
      },
    },
  );
};
